<div class="svg">
  <img src="/assets/coffe.jpg" />
  @if (source === 'Text') {
    <ng-container
      [ngTemplateOutlet]="svg"
    ></ng-container>
  }
  @if (mode === 'Multi' && source === 'Text') {
    <ng-container [ngTemplateOutlet]="svg"></ng-container>
    <ng-container [ngTemplateOutlet]="svg"></ng-container>
    <ng-container [ngTemplateOutlet]="svg"></ng-container>
  }
  @if (source === 'Image' && fileName$ | async) {
    <div
      [ngClass]="{ multi: mode === 'Multi' }"
      [ngStyle]="{ opacity: opacity }"
      class="img"
      >
      <ng-container [ngTemplateOutlet]="img"></ng-container>
      @if (mode === 'Multi') {
        <ng-container [ngTemplateOutlet]="img"></ng-container>
        <ng-container [ngTemplateOutlet]="img"></ng-container>
        <ng-container [ngTemplateOutlet]="img"></ng-container>
      }
    </div>
  }
</div>
<ng-template #img><img [src]="url$ | async" class="watermark" /></ng-template>
<ng-template #svg>
  <svg height="100" viewBox="0 0 200 200" width="200">
    <defs>
      <filter id="innerShadow">
        <feConvolveMatrix
          divisor="1"
          in="SourceAlpha"
          order="3"
          result="bevel"
        kernelMatrix=""></feConvolveMatrix>
        <feMerge>
          <feMergeNode in="bevel" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    @if (showLines) {
      <g>
        <line
          [attr.opacity]="lineOpacity"
          style="stroke: rgb(0, 0, 0); stroke-width: 1"
          x1="70"
          x2="0"
          y1="70"
          y2="0"
          />
          <line
            [attr.opacity]="lineOpacity"
            style="stroke: rgb(0, 0, 0); stroke-width: 1"
            x1="130"
            x2="200"
            y1="70"
            y2="0"
            />
            <line
              [attr.opacity]="lineOpacity"
              style="stroke: rgb(0, 0, 0); stroke-width: 1"
              x1="0"
              x2="70"
              y1="200"
              y2="130"
              />
              <line
                [attr.opacity]="lineOpacity"
                style="stroke: rgb(0, 0, 0); stroke-width: 1"
                x1="130"
                x2="200"
                y1="130"
                y2="200"
                />
                <line
                  [attr.opacity]="lineOpacity"
                  style="stroke: rgb(255, 255, 255); stroke-width: 1"
                  x1="0"
                  x2="70"
                  y1="1"
                  y2="71"
                  />
                  <line
                    [attr.opacity]="lineOpacity"
                    style="stroke: rgb(255, 255, 255); stroke-width: 1"
                    x1="130"
                    x2="200"
                    y1="71"
                    y2="1"
                    />
                    <line
                      [attr.opacity]="lineOpacity"
                      style="stroke: rgb(255, 255, 255); stroke-width: 1"
                      x1="0"
                      x2="70"
                      y1="199"
                      y2="129"
                      />
                      <line
                        [attr.opacity]="lineOpacity"
                        style="stroke: rgb(255, 255, 255); stroke-width: 1"
                        x1="130"
                        x2="200"
                        y1="131"
                        y2="199"
                        />
                      </g>
                    }
                    <text
                      #textElement
                      [attr.font-size]="startSize"
                      [attr.opacity]="opacity"
                      alignment-baseline="middle"
                      fill="#000"
      style="
        font-weight: bold;
        fill: white;
        font-family: Arial;
      "
                      text-anchor="middle"
                      x="50%"
                      y="50%"
                      >
                      <!--      filter: url(#innerShadow);-->
                      <![CDATA[{{ text | langPicker | async }}]]>
                    </text>
                  </svg>
                </ng-template>
